export default "__VITE_ASSET__py7Zre2r__"